export const initialState = {
    user: null,
    name: null,
    token: `Bearer ${ localStorage.getItem('token') }`,
    id: null,
    lvl: null,
    depto: null,
    priv: null,
    privilegios: [],
    theme: localStorage.getItem('theme') ?? 'dark',
    reviews: null,
    totales: null,
    revisados: null,
    botones: null,
    selectedKeys: null,
    prorrogas: null,
    puesto: null,
    phone: null,
    contratos: null,
    multas: null,
    puestoNombre: null,
    estatus: null,
    verificado: null,
    tokenFirebase: null,
    accessFtp: 0,
    paddingContent: 24,
    marginContent: '24px 16px',
    avisoPrivacidad: true,
};

const reducer = (state, action) => {
    switch (action.type) {
    case 'ADD_TOKEN': {
        const { token } = action.item;
        localStorage.setItem('token', token);
        return {
            ...state,
            token: `Bearer ${ token }`,
        };
    }
    case 'ADD_IDAUDITORIA': {
        const { idAuditoria } = action.item;
        return {
            ...state,
            idAuditoria,
        };
    }

    case 'ADD_USER_INFO': {
        const { user, name, mail, id, lvl, depto, priv, privilegios = '[]', prorrogas, puesto, phone, contratos, multas, puestoNombre, entidad, estatus, verificado, accessFtp, avisoPrivacidad = true } = action.item;
        return {
            ...state,
            user: user?.toString(),
            name: name?.toString(),
            mail: mail?.toString(),
            id: id?.toString(),
            lvl: lvl?.toString(),
            depto: depto?.toString(),
            priv: priv?.toString(),
            privilegios,
            prorrogas: prorrogas?.toString(),
            puesto: puesto?.toString(),
            phone: phone?.toString(),
            contratos: contratos?.toString(),
            multas: multas?.toString(),
            puestoNombre: puestoNombre?.toString(),
            entidad: entidad?.toString(),
            estatus: estatus?.toString(),
            verificado: verificado?.toString(),
            accessFtp: accessFtp?.toString(),
            avisoPrivacidad,
        };
    }

    case 'DELETE_USER_INFO': {
        localStorage.clear();
        return initialState;
    }
    case 'CHANGE_THEME': {
        const { theme } = action.item;
        localStorage.setItem('theme', theme);
        return {
            ...state,
            theme,
        };
    }
    case 'NOTIFICATION_TRIGGER': {
        const { type } = action.item;
        const KEY = `notificationTrigger${ type }`;
        return {
            ...state,
            [KEY]: !state[KEY],
        };
    }
    case 'NOTIFICATION_URL': {
        const { type2 } = action.item;
        const KEY3 = `notificationUrl${ type2 }`;
        return {
            ...state,
            [KEY3]: !state[KEY3],
        };
    }
    case 'TRIGGER_ACTION': {
        const KEY2 = `trigger${ action.item }`;
        return {
            ...state,
            [KEY2]: !state[KEY2],
        };
    }
    case 'PLANEACION': {
        const { reviews, totales, revisados, botones, selectedKeys } = action.item;
        return {
            ...state,
            reviews,
            totales,
            revisados,
            botones,
            selectedKeys,
        };
    }
    case 'ADD_CEDULA_NOMINA': {
        const {
            record,
            nombreEntidad,
            table,
            nombreArchivo,
            periodo,
            fechaInicio,
            fechaFin,
            quincena,
            periodoRevision,
            periodoRevisionText,
            totalGen,
            typeCed,
            noNomTimbrados,
            noNomDispercion,
            reporteNoTimbrados,
            titulo,
        } = action.item;
        return {
            ...state,
            record,
            nombreEntidad,
            nombreArchivo,
            periodo,
            fechaInicio,
            fechaFin,
            quincena,
            periodoRevision,
            periodoRevisionText,
            table,
            totalGen,
            typeCed,
            noNomTimbrados,
            noNomDispercion,
            reporteNoTimbrados,
            titulo,
        };
    }
    case 'VALIDAR_CORREO': {
        const validadoActual = action.item;
        return {
            ...state,
            verificado: (validadoActual === '2') ? '3' : '1',
        };
    }
    case 'VALIDAR_TELEFONO': {
        const validadoActual = action.item;
        return {
            ...state,
            verificado: (validadoActual === '1') ? '3' : '2',
        };
    }
    case 'ADD_TOKEN_FIREBASE': {
        const tokenFirebase = action.item;
        return {
            ...state,
            tokenFirebase,
        };
    }
    case 'CHANGE_STYLE_CONTENT': {
        const { paddingContent = 24, marginContent = '24px 16px' } = action.item;
        return {
            ...state,
            paddingContent,
            marginContent,

        };
    }
    case 'RESET_STYLE_CONTENT': {
        return {
            ...state,
            paddingContent: 24,
            marginContent: '24px 16px',
        };
    }
    case 'SET_AVISO_PRIVACIDAD': {
        return {
            ...state,
            avisoPrivacidad: true,
        };
    }
    default:
        return state;
    }
};
export default reducer;
